import { FeatureToggleClientService } from 'feature-toggle-client';
export const RdStationOAuth = 'rd-station-o-auth';
export class RdStationFeatures {
    static async rdStationOAuthEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(RdStationOAuth);
    }
}
